// Editorial section header — number in italic terra, title in display serif.
import type { ReactNode } from "react";

interface Props {
  num: string;
  title: string;
  lede?: ReactNode;
}

export function SectionHead({ num, title, lede }: Props) {
  return (
    <div className="mb-6 flex items-baseline gap-5">
      <span className="font-display text-4xl italic leading-none text-terra [font-variation-settings:'opsz'_60,'SOFT'_0,'WONK'_0,'wght'_300]">
        {num}
      </span>
      <div>
        <h2 className="text-3xl tracking-tight">{title}</h2>
        {lede && <p className="mt-3 max-w-prose text-ink-soft">{lede}</p>}
      </div>
    </div>
  );
}
